/**
  * @dativejs/helper v1.0.0
  * (c) 2022-2022 Tobithedev <ucheemekatobi@gmail.com>
  * https://github.com/dativeJs/helper
  * Released under the MIT License.
*/
var index = {
    install({Dative}){
     var $range = function (start, stop, step) {
              if (step === void 0) {
                step = 1;
              }
  
              // Accept $range(10) and expect 1...10
             if (typeof stop === 'undefined') {
                stop = start;
                start = start ? 1 : 0;
             } // Accept $range(20, 10) and expect 20...10
  
  
              var reverse = start > stop;
  
              if (reverse) {
                var _ref = [stop, start];
                start = _ref[0];
                stop = _ref[1];
              } // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Sequence_generator_range
              var range = Array.from({
                length: (stop - start) / step + 1
              }, function (_, i) {
                return start + i * step;
              });
              return reverse ? range.reverse() : range;
          };
      Dative.defineProperty('range',()=>{
        return (start, stop, step)=>{
          return $range(start, stop, step)
        }
      });
      /**
       * @param {Function} callback (()=> console.log('hi'))
       * @param {Number} time delay
      */
      var $interval = function(callback,time){
        if (time == void 0) {
          time = 0;
        }
       return setInterval(callback,time);
      };
      var $timeout = function(callback,time){
        if (time == void 0) {
          time = 0;
        }
        return setTimeout(callback, time);
      };
      
      Dative.defineProperty('interval',()=>{
        return (callback,time)=>{
          return $interval(callback,time)
        }
      });
      
      Dative.defineProperty('timeout', () => {
        return (callback, time) => {
          return $timeout(callback, time)
        }
      });
      
      
      
      Dative.defineProperty('truncate', () => {
              return (...parameters) => {
                  if (typeof parameters[0] !== 'string') return parameters[0]
  
                  // If the second parameter isn't truthy, return the full string
                  if (!parameters[1]) return parameters[0]
  
                  // if only a number or string is passed in, keep it simple
                  if (typeof parameters[1] !== 'object') {
                      return appendEllipsis(parameters[0].slice(0, parameters[1]), parameters)
                  }
  
                  // If words or characters is set, also check that they are truthy. Setting to 0, for example, shoudld show all
                  if (Object.prototype.hasOwnProperty.call(parameters[1], 'words') && parameters[1].words) {
                      return appendEllipsis(parameters[0].split(' ').splice(0, parameters[1].words).join(' '), parameters)
                  }
                  if (Object.prototype.hasOwnProperty.call(parameters[1], 'characters') && parameters[1].characters) {
                      return appendEllipsis(parameters[0].slice(0, parameters[1].characters), parameters)
                  }
                  return parameters[0]
              }
          });
      
    function appendEllipsis(string, parameters) {
          if (parameters[0].length <= string.length) return string
          let ellipsis = '…';
          // 3rd parameter is an optional '…' override (soon to be deprecated)
          if (typeof parameters[2] !== 'undefined') {
              ellipsis = parameters[2];
          }
          // If the second parameter is an object
          if (Object.prototype.hasOwnProperty.call(parameters[1], 'ellipsis')) {
              ellipsis = parameters[1].ellipsis;
          }
          return string + ellipsis
      }
      class Config {
      constructor() {
          this.values = {
              breakpoints: {
                  xs: 0,
                  sm: 640,
                  md: 768,
                  lg: 1024,
                  xl: 1280,
                  '2xl': 1536,
              },
          };
      }
  
      get(property) {
          return this.values[property] ? this.values[property] : null
      }
  }
  
  const config = new Config();
  
      Dative.defineProperty('screen', () => {
        return (breakpoint) => {
          // Get current window width
          const width = window.innerWidth;
      
          // Early return if breakpoint is provided as number
          if (Number.isInteger(breakpoint)) return breakpoint <= width
      
          // Get breakpoints from Config
          const configBreakpoints = config.get('breakpoints');
      
          // Check if breakpoint exists
          if (configBreakpoints[breakpoint] === undefined) {
            Dative.utlis.warn('Undefined $screen property: ' + breakpoint);
          }
      
          // Finally compare breakpoint with window width and return as boolean
          return configBreakpoints[breakpoint] <= width
        }
      });
    }
  };

export { index as default };
//# sourceMappingURL=dative-helper.esm.js.map
